import { render, staticRenderFns } from "./SearchNavItemFieldSelectWithName.vue?vue&type=template&id=351f6298&scoped=true&"
import script from "./SearchNavItemFieldSelectWithName.vue?vue&type=script&lang=js&"
export * from "./SearchNavItemFieldSelectWithName.vue?vue&type=script&lang=js&"
import style0 from "./SearchNavItemFieldSelectWithName.vue?vue&type=style&index=0&id=351f6298&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351f6298",
  null
  
)

export default component.exports